/* Homecret · carrusel de banners (hero de la home y páginas de tienda).
   Fundido entre diapositivas cada data-interval segundos. Se detiene con el ratón o el foco del teclado dentro,
   con la pestaña en segundo plano y si el visitante pide menos movimiento. Las ocultas quedan inert (sin tabulación). */
(() => {
  if (window.hcCarouselReady) return;
  window.hcCarouselReady = true;

  const init = (root) => {
    if (root.dataset.hcsReady) return;
    root.dataset.hcsReady = '1';
    const slides = [...root.querySelectorAll(':scope > .hcs__slide')];
    if (slides.length < 2) return;
    const dots = [...root.querySelectorAll('[data-hcs-dot]')];
    const ms = Math.max(3, Number(root.dataset.interval) || 6) * 1000;
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let i = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    let timer = null;
    let hold = false;

    const show = (n) => {
      slides[i].classList.remove('is-active');
      slides[i].inert = true;
      slides[i].querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      if (dots[i]) dots[i].removeAttribute('aria-current');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      slides[i].inert = false;
      slides[i].querySelectorAll('a').forEach((a) => a.removeAttribute('tabindex'));
      if (dots[i]) dots[i].setAttribute('aria-current', 'true');
      root.dataset.tone = slides[i].dataset.tone || 'dark';
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const play = () => { stop(); if (!still && !hold && !document.hidden) timer = setInterval(() => show(i + 1), ms); };

    dots.forEach((d) => d.addEventListener('click', () => { show(Number(d.dataset.hcsDot)); play(); }));
    root.addEventListener('mouseenter', () => { hold = true; stop(); });
    root.addEventListener('mouseleave', () => { hold = false; play(); });
    root.addEventListener('focusin', () => { hold = true; stop(); });
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) { hold = false; play(); } });
    document.addEventListener('visibilitychange', play);
    root.dataset.tone = slides[i].dataset.tone || 'dark';
    play();
  };

  const run = () => document.querySelectorAll('[data-hcs]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Editor de temas: la sección se vuelve a pintar al cambiar ajustes
  document.addEventListener('shopify:section:load', run);
})();
